import { apiInstance } from '../../api';

const route = '/apartment/build';

export class BuildService {
  static async fetchBuilds(queueId) {
    return apiInstance.get(`${route}/${queueId}`);
  }

  static async createBuild(name, queueId) {
    return apiInstance.post(route, { name, apartmentQueueId: queueId });
  }

  static async changeBuild(sectionId, queueId, newName) {
    return apiInstance.put(`${route}/${sectionId}`, {
      name: newName,
      apartmentQueueId: queueId,
    });
  }

  static async deleteBuild(sectionId) {
    return apiInstance.delete(`${route}/${sectionId}`);
  }
}
